import { useCallback } from 'react';
import { useLatestValue } from './use-latest-value';
export const useEvent = cb => {
  const cache = useLatestValue(cb);
  return useCallback((...args) => cache.current(...args), [cache]);
};